import { initTutorial } from '../js/tutorial-shared/tutorial-core.js';

const pendingFrames = new Map();
let nextFrameId = 1;
let tickComponentReady = false;

function ensureTutorialTickComponent() {
  if (tickComponentReady || typeof AFRAME === 'undefined') {
    return;
  }
  if (!AFRAME.components['tutorial-tick']) {
    AFRAME.registerComponent('tutorial-tick', {
      tick: function () {
        if (!pendingFrames.size) {
          return;
        }
        const batch = Array.from(pendingFrames.entries());
        pendingFrames.clear();
        for (let i = 0; i < batch.length; i += 1) {
          const callback = batch[i][1];
          if (typeof callback === 'function') {
            callback();
          }
        }
      }
    });
  }
  const scene = document.getElementById('main-scene');
  if (scene && !scene.getAttribute('tutorial-tick')) {
    scene.setAttribute('tutorial-tick', '');
  }
  tickComponentReady = true;
}

function scheduleFrame(callback) {
  ensureTutorialTickComponent();
  const id = nextFrameId;
  nextFrameId += 1;
  pendingFrames.set(id, callback);
  return id;
}

function cancelFrame(id) {
  pendingFrames.delete(id);
}

function waitFrame() {
  return new Promise(function (resolve) {
    scheduleFrame(resolve);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureTutorialTickComponent);
} else {
  ensureTutorialTickComponent();
}

initTutorial({
  isVrPage: true,
  scheduleFrame: scheduleFrame,
  cancelFrame: cancelFrame,
  waitFrame: waitFrame
});
